import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from "@angular/core";
import { Constants } from "@app/constants/constants";
import { MethodsHelper } from "@app/helpers/methods.helper";
import { Branch } from "@app/models/branch";
import { GuaranteeAgreement } from "@app/models/guarantee-agreement";
import { AuthenticationService } from "@app/services/authentication.service";
import { BranchService } from "@app/services/branch.service";
import { GuaranteeService } from "@app/services/guarantee.service";
import { NotificationService } from "@app/services/notification.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'app-guarantee-restitution-popup',
    templateUrl: 'guarantee-restitution-popup.component.html',
    styleUrls: ['guarantee-restitution-popup.component.css'],
    standalone: false
})

export class GuaranteeRestitutionPopupComponent implements OnInit, OnChanges {
    @Input() displayDialog: boolean;
    @Input() guaranteeAgreement: GuaranteeAgreement;
    @Output() onSubmit = new EventEmitter();
    @Output() onCancel = new EventEmitter();
    @Output() restitutionReload = new EventEmitter();

    @ViewChild('form') form: any;

    guaranteeRestitution: any;

    submittedForm: boolean = false;

    validationMessages: object;

    pageIndex = 0;
    pageSize = Constants.PAGE_ITEM_COUNT;
    totalElements: number;

    defaultPageParams = {
        size: 10,
        page: 0
    }

    yearRange: string;

    branchCodeList: Array<Branch>;


    constructor(
        private notificationService: NotificationService,
        private branchService: BranchService,
        private guaranteeService: GuaranteeService,
        private authenticationService: AuthenticationService,
        private datePipe: DatePipe,
        private translate: TranslateService
    ) {
    }

    ngOnInit() {
        if (!this.guaranteeRestitution) {
            this.guaranteeRestitution = new Object();
            this.guaranteeRestitution.documentNumber = MethodsHelper.randomString(10);
            this.guaranteeRestitution.guaranteeAgreementNumber = this.guaranteeAgreement.guaranteeAgreementNumber;
            this.guaranteeRestitution.date = this.datePipe.transform(localStorage.getItem('businessDay') ? new Date(localStorage.getItem('businessDay')) : new Date(), 'dd-MM-yyyy');
            this.guaranteeRestitution.amount = this.guaranteeAgreement.outstandingAmount;
            this.guaranteeRestitution.channelCode = Constants.CHANNEL.CHANNEL_CODE;
            this.guaranteeRestitution.currency = this.guaranteeAgreement.currency;
            this.guaranteeRestitution.description = this.guaranteeAgreement.description;
            this.guaranteeRestitution.initiatedUserId = this.authenticationService.getCurrentUserId();
            this.guaranteeRestitution.branchId = this.guaranteeAgreement.branchId;
            this.guaranteeRestitution.customerSpecificOptions = this.guaranteeAgreement.customerSpecificOptions;
            this.guaranteeRestitution.purpose = this.guaranteeAgreement.guaranteeAgreementNumber + ' ' + 'guarantee restitution';
        }
        this.validationMessages = new Object();
        this.yearRange = MethodsHelper.getYearRange(0);
        this.getBranches();
    }

    ngOnChanges() {
        this.getRestitutionInfo();
    }

    getRestitutionInfo() {
        this.guaranteeService.getRestitutionInfo(this.guaranteeAgreement.id).subscribe({
            next: (data) => {
                this.guaranteeRestitution.documentNumber = data.documentNumber;
                this.guaranteeRestitution.guaranteeAgreementNumber = data.agreementNumber;
                this.guaranteeRestitution.date = data.date;
                this.guaranteeRestitution.amount = data.outstandingAmount;
                this.guaranteeRestitution.currency = data.currency;
                this.guaranteeRestitution.branchId = data.branchId;
                this.guaranteeRestitution.purpose = data.purpose;
            },
            error: (err) => {
                let msg = MethodsHelper.showErrorMessageStyling(err);
                this.notificationService.showError("<div class='row'><p class='col-1 d-flex align-items-center'><i class='fa fa-times-circle'></i></p><p class='col'> " + `${msg}` + "</p></div>",
                    "");
            }
        });
    }

    getBranches() {
        const pageOption = {
            size: 10000,
            page: 0
        }
        const pageParams = { ...this.defaultPageParams, ...pageOption };
        this.branchService.getList(pageParams).subscribe(data => {
            this.branchCodeList = data.content;
            this.branchCodeList.forEach(code => {
                this.guaranteeRestitution.branchId = JSON.parse(this.authenticationService.getUserRoles())[0]?.userBranchId;
            })
        });
    }

    onSave() {
        this.submittedForm = true;
        if (this.validateForm()) {
            this.guaranteeService.makeRestitution(this.guaranteeAgreement.id, this.guaranteeRestitution).subscribe({
                next: (data) => {
                    this.notificationService.showHTMLMessage("<i class='fa fa-check-circle' style='line-height: 2'></i> <p>" + `Successfully restituted.` + "</p>", "");
                    this.cancel();
                    this.restitutionReload.emit();
                },
                error: (err) => {
                    let msg = MethodsHelper.showErrorMessageStyling(err);
                    this.notificationService.showError("<div class='row'><p class='col-1 d-flex align-items-center'><i class='fa fa-times-circle'></i></p><p class='col'> " + `${msg}` + "</p></div>",
                        "");
                }
            });
        } else {
            this.notificationService.showErrorMessage(this.translate.instant('error.something_incorrect'))}
    }

    validateForm() {
        for (let key in this.validationMessages) {
            if (this.validationMessages[key]) {
                return false;
            }
        }
        if (this.form.form) {
            return this.form.form.valid
        }
        return false;
    }

    cancel() {
        this.onCancel.emit();
    }

    changeBranch(value) {
        if (this.branchCodeList) {
            for (const element of this.branchCodeList) {
                if (element.id == value) {
                    this.guaranteeRestitution.branchId = element.id;
                    break;
                }
            }
        }
    }

    onAmountFocusOut(event) {
        this.guaranteeRestitution.amount = MethodsHelper.amountFieldFocusOut(event);
    }

    numberOnly(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        return !(charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57))
    }
}